<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>

<div class="card">
  <div class="card-header text-center" style="background-color: #be0c4d;">
    <h4 style="color: white;">Crear fuente</h4>
  </div>
  <div class="card-body">
    <form action="">
      <div class=" container-fluid" id="operacionEstadistica">
        <label><b>Operación Estadística</b></label>
        <div class="row">
          <div class="col-3">
            <label class="form-check-label" for="flexCheckDefault">
              Cartera Hipotecaria de Vivienda - CHV
            </label>
          </div>
          <div class="col-1">
            <input class="form-check-input" type="checkbox" name="fuenteCHV" [formControl]="AuxFuenteCHV"
            data-bs-toggle="collapse" data-bs-target="#FuenteCHV"  aria-controls="FuenteCHV">
          </div>
          <div class="col-3">
            <label class="form-check-label" for="flexCheckDefault">
              Financiación de Vivienda - FIVI
            </label>
          </div>
          <div class="col-1">
            <input class="form-check-input" type="checkbox" name="fuenteFIVI" [formControl]="AuxFuenteFIVI"
            data-bs-toggle="collapse" data-bs-target="#FuenteFIVI"  aria-controls="FuenteFIVI">
          </div>
        </div>
      </div>
      <br>
      <div class=" container-fluid">
        <b>Ubicación y Datos Generales</b>
        <div class="row">
          <div class="col-3">
            <div><label>NIT</label></div>
            <div><input type="text" class="form-control" name="nit" [formControl]="Nit" (change)="UpdateVariableNuevaFuente()"></div>
          </div>
          <div class="col-3">
            <div><label>Superintendecia</label></div>
            <div>
              <select class="form-select" aria-label="Default select example" name="super" [formControl]="CodigoSuperintendencia"
              (change)="getTiposBySupers($event.target.value)">
                <option selected value="">Seleccionar</option>
                <option *ngFor="let super of superintendencias" value="{{super.codigo}}">{{super.codigo}} - {{super.nombre}}</option>
              </select>
            </div>
          </div>
          <div class="col-3">
            <div><label>Tipo de entidad</label></div>
            <div>
              <select class="form-select" aria-label="Default select example" name="tipo" [formControl]="CodigoTipoEntidad"
              (change)="UpdateVariableNuevaFuente()">
                <option selected value="">Seleccionar</option>
                <option *ngFor="let tipo of tiposEntidad" value="{{tipo.codigo}}">{{tipo.codigo}} - {{tipo.nombre}}</option>
              </select>
            </div>
          </div>
          <div class="col-3">
            <div><label>Código entidad</label></div>
            <div><input type="text" class="form-control" name="codigo" [formControl]="CodigoEntidad" maxlength="6"
              (change)="UpdateVariableNuevaFuente()"></div>
          </div>
        </div>
      </div>
      <div class=" container-fluid">
        <div class="row">
          <div class="col-6">
            <div><label>Razón social</label></div>
            <div><input type="text" class="form-control" name="nombre" [formControl]="RazonSocial" maxlength="100"
              (change)="UpdateVariableNuevaFuente()" oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"></div>
          </div>
          <div class="col-3">
            <div><label>Departamento</label></div>
            <div>
              <select class="form-select" aria-label="Default select example" name="depto" [formControl]="CodigoDepto"
              (change)="getMunicByDepto($event.target.value)">
                <option selected value="">Seleccionar</option>
                <option *ngFor="let depto of departamentos" value="{{depto.codigo}}">{{depto.codigo}} - {{depto.nombre}}</option>
              </select>
            </div>
          </div>
          <div class="col-3">
            <div><label>Municipio</label></div>
            <div>
              <select class="form-select" aria-label="Default select example" name="muni" [formControl]="CodigoMpio"
              (change)="UpdateVariableNuevaFuente()">
                <option selected value="">Seleccionar</option>
                <option *ngFor="let muni of Municipios" value="{{muni.codmpio}}">{{muni.codmpio}} - {{muni.nommpio}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class=" container-fluid">
        <div class="row">
          <div class="col-6">
            <div><label>Dirección</label></div>
            <div class="input-group">
              <input type="text" class="form-control" name="direccionfuente" [formControl]="Direccion" aria-label="Recipient's username" aria-describedby="button-addon2" disabled>
              <button class="btn btn-outline-secondary" type="button" data-bs-toggle="modal" data-bs-target="#modalPoll-NormDir" (click)="NormalizandoDirecccion()"><i class="fa fa-location-arrow" aria-hidden="true"></i></button>
            </div>
          </div>
          <div class="col-3">
            <div><label>Teléfono</label></div>
            <div><input type="text" class="form-control" name="telefono" [formControl]="Telefono" maxlength="22" oninput="this.value = this.value.replace(/[^0-9]/g, '')" (change)="UpdateVariableNuevaFuente()"></div>
          </div>
          <div class="col-3">
            <div><label>Código financiador</label></div>
            <div>
              <select class="form-select" aria-label="Default select example" name="financiador" [formControl]="CodigoEntidadFinanciadora"
              (change)="UpdateVariableNuevaFuente()">
                <option selected value="">Seleccionar</option>
                <option value="1">1 - Fondo nacional del ahorro</option>
                <option value="2">2 - Cooperativas, fondos de empleados y fondos de vivienda</option>
                <option value="3">3 - Banca hipotecaria</option>
                <option value="4">4 - Banca comercial</option>
                <option value="5">5 - Cajas de compensación</option>
                <option value="6">6 - Otros colectores de cartera</option>
                <option value="7">7 - Otros esablecimientos de crédito</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="container-fluid collapsed multi-collapse" id="FuenteCHV" *ngIf="AuxFuenteCHV.value">
        <div class="row">
          <div class="col-6">
            <b>Datos del Usuario Responsable CHV</b>
            <div class="row">
              <div class="col-6">
                <div><label>Nombres</label></div>
                <div><input type="text" class="form-control" name="nombrechv" maxlength="100" [formControl]="ResponsableChvNombre"
                  (change)="UpdateVariableNuevaFuente()"></div>
              </div>
              <div class="col-6">
                <div><label>Cargo</label></div>
                <div><input type="text" class="form-control" name="cargochv" maxlength="100" [formControl]="ResponsableChvCargo"
                  (change)="UpdateVariableNuevaFuente()"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div><label>Teléfono</label></div>
                <div><input type="text" class="form-control" name="telefonochv" maxlength="10" [formControl]="ResponsableChvTelefono"
                  (change)="UpdateVariableNuevaFuente()" oninput="this.value = this.value.replace(/[^0-9]/g, '')"></div>
              </div>
              <div class="col-6">
                <div><label>Email</label></div>
                <div><input type="text" class="form-control" name="emailchv" maxlength="50" [formControl]="ResponsableChvCorreo"
                  (change)="UpdateVariableNuevaFuente()"></div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <b>Datos de quien diligencia la información CHV</b>
            <div class="row">
              <div class="col-6">
                <div><label>Nombres</label></div>
                <div><input type="text" class="form-control" name="nombreinfochv" maxlength="100" [formControl]="ResponsableInfoChvNombre"
                  (change)="UpdateVariableNuevaFuente()"></div>
              </div>
              <div class="col-6">
                <div><label>Cargo</label></div>
                <div><input type="text" class="form-control" name="cargoinfochv" maxlength="100" [formControl]="ResponsableInfoChvCargo"
                  (change)="UpdateVariableNuevaFuente()"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div><label>Teléfono</label></div>
                <div><input type="text" class="form-control" name="telefonoinfochv" maxlength="10" [formControl]="ResponsableInfoChvTelefono"
                  (change)="UpdateVariableNuevaFuente()" oninput="this.value = this.value.replace(/[^0-9]/g, '')"></div>
              </div>
              <div class="col-6">
                <div><label>Email</label></div>
                <div><input type="text" class="form-control" name="emailinfochv" maxlength="50" [formControl]="ResponsableInfoChvCorreo"
                  (change)="UpdateVariableNuevaFuente()"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="container-fluid collapsed multi-collapse" id="FuenteFIVI" *ngIf="AuxFuenteFIVI.value">
        <div class="row">
          <div class="col-6">
            <b>Datos del Usuario Responsable FIVI</b>
            <div class="row">
              <div class="col-6">
                <div><label>Nombres</label></div>
                <div><input type="text" class="form-control" name="nombrefivi" maxlength="100" [formControl]="ResponsableFiviNombre"
                  (change)="UpdateVariableNuevaFuente()"></div>
              </div>
              <div class="col-6">
                <div><label>Cargo</label></div>
                <div><input type="text" class="form-control" name="cargofivi" maxlength="100" [formControl]="ResponsableFiviCargo"
                  (change)="UpdateVariableNuevaFuente()"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div><label>Teléfono</label></div>
                <div><input type="text" class="form-control" name="telefonofivi" maxlength="10" [formControl]="ResponsableFiviTelefono"
                  (change)="UpdateVariableNuevaFuente()" oninput="this.value = this.value.replace(/[^0-9]/g, '')"></div>
              </div>
              <div class="col-6">
                <div><label>Correo</label></div>
                <div><input type="text" class="form-control" name="emailfivi" maxlength="50" [formControl]="ResponsableFiviCorreo"
                  (change)="UpdateVariableNuevaFuente()"></div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <b>Datos de quien diligencia la información FIVI</b>
            <div class="row">
              <div class="col-6">
                <div><label>Nombres</label></div>
                <div><input type="text" class="form-control" name="nombreinfofivi" maxlength="100" [formControl]="ResponsableInfoFiviNombre"
                  (change)="UpdateVariableNuevaFuente()"></div>
              </div>
              <div class="col-6">
                <div><label>Cargo</label></div>
                <div><input type="text" class="form-control" name="cargoinfofivi" maxlength="100" [formControl]="ResponsableInfoFiviCargo"
                  (change)="UpdateVariableNuevaFuente()"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div><label>Teléfono</label></div>
                <div><input type="text" class="form-control" name="telefonoinfofivi" maxlength="10" [formControl]="ResponsableInfoFiviTelefono"
                  (change)="UpdateVariableNuevaFuente()" oninput="this.value = this.value.replace(/[^0-9]/g, '')"></div>
              </div>
              <div class="col-6">
                <div><label>Correo</label></div>
                <div><input type="text" class="form-control" name="emaiinfofivi" maxlength="50" [formControl]="ResponsableInfoFiviCorreo"
                  (change)="UpdateVariableNuevaFuente()"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </form>
  </div>
  <div class="card-footer">
    <button type="button" class="btn btn-secondary" (click)="regresarFuentes()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="GuardarNuevaFuente2()"
      [disabled]="btnguardar" *ngIf="!BTNguardar()" >Guardar</button>
    <button type="button" class="btn btn-secondary" (click)="VerificarCampos()" *ngIf="BTNguardar()" >Guardar</button>
  </div>
</div>

</body>

<!--Modal Cargando-->
<button class="btn btn-primary btn-sm" #openmodalcargando data-toggle="modal"  data-target="#modal-cargando" style="visibility: hidden;"
 data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-md" id="modal-cargando" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-body">
        <div class="card-body container-fluid">
          <br>
          <div class="row">
            <div class="col-auto" style="margin: auto;">
              <h5>Cargando y verificando información, espere un momento...</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" #cerrarmodalcargando
              style="visibility: hidden;">
                <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
              </button>
            </div>
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-danger" role="status" style="width: 60px; height: 60px;">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Modal advertencia administracion de variables-->
<button class="btn btn-primary btn-sm" #openmodalAdminvar data-bs-toggle="modal" data-bs-target="#modal-advertencia" style="visibility: hidden;" data-bs-backdrop="static" data-bs-keyboard="false">ModalAdvertencia</button>
 <div class="modal fade bd-example-modal-md" id="modal-advertencia" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
 aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header" id="modalheader">
        <h5 class="modal-title" id="ModalLabel" style="color: white;">Importante</h5>
      </div>
      <div class="modal-body">
        <div class="card-body container-fluid">
          <br>
          <div class="row">
            <div class="col-auto" style="margin: auto;">
              <div class="row" style="text-align: center;">
                <p>Recuerde dirigirse a la sección <b>Administración Variables Reporte</b> para realizar la parametrización de las variables del reporte para la operación estadística de la fuente.</p>
              </div>
            </div>
          </div>
          <br>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" style="visibility: hidden;" #cerrarmodalAdminvar>Cancelar</button>
        <button type="submit" class="btn btn-primary" (click)="cerrarAdvertencia()">Continuar</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade right"  id="modalPoll-NormDir" aria-hidden="true" data-backdrop="false">
  <div class="modal-dialog modal-full-height modal-right modal-notify modal-info modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header" id="modalheader">
        <h5 class="modal-title" id="ModalLabel" style="color: white;">Ingresar Dirección</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row"><b>Por favor diligencia todos los campos que tiene *</b></div>
          <br>
          <div class="row">
            <div class="col-3"><label>Seleccione el tipo de vía: </label></div>
            <div class="col">
              <select class="form-select" name="tipovia" [formControl]="TipoViaPrincipal">
                <option value="">Sin vía</option>
                <option value="AU">(AU) Autopista</option>
                <option value="AV">(AV) Avenida</option>
                <option value="AC">(AC) Avenida Calle</option>
                <option value="AK">(AK) Avenida Carrera</option>
                <option value="BLV">(BLV) Boulevar</option>
                <option value="CL">(CL) Calle</option>
                <option value="CM">(CM) Camino</option>
                <option value="KR">(KR) Carrera</option>
                <option value="CV">(CV) Circunvalar</option>
                <option value="DG">(DG) Diagonal</option>
                <option value="PRJ">(PRJ) Paraje</option>
                <option value="PSJ">(PSJ) Pasaje</option>
                <option value="PAS">(PAS) Paseo</option>
                <option value="TV">(TV) Transversal</option>
                <option value="TC">(TC) Troncal</option>
                <option value="VT">(VT) Variante</option>
              </select>
            </div>
            <div class="col-1"><b>*</b></div>
          </div>
          <br>
            <div class="row">
              <div class="col-6"><label>Ingrese el número o nombre de la vía principal: </label></div>
              <div class="col"><input type="text" name="numnomvia" class="form-control" [formControl]="NombreViaPrincipal" maxlength="20" oninput="this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '')"></div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-6"><label>Seleccione la letra que acompaña la nomencaltura: </label></div>
              <div class="col">
                <select class="form-select" name="acomnomen" [formControl]="LetraViaPrincipal">
                  <option value="">Sin letra</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                  <option value="E">E</option>
                  <option value="F">F</option>
                  <option value="G">G</option>
                  <option value="H">H</option>
                  <option value="I">I</option>
                  <option value="J">J</option>
                  <option value="K">K</option>
                  <option value="L">L</option>
                  <option value="M">M</option>
                  <option value="N">N</option>
                  <option value="O">O</option>
                  <option value="P">P</option>
                  <option value="Q">Q</option>
                  <option value="R">R</option>
                  <option value="S">S</option>
                  <option value="T">T</option>
                  <option value="U">U</option>
                  <option value="V">V</option>
                  <option value="W">W</option>
                  <option value="X">X</option>
                  <option value="Y">Y</option>
                  <option value="Z">Z</option>
                </select>
              </div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-4"><label>Seleccione el prefijo: </label></div>
              <div class="col">
                <select class="form-select" name="prefijo" [formControl]="Prefijo">
                  <option value="">Sin prefijo</option>
                  <option value="Bis">Bis</option>
                </select>
              </div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-4"><label>Seleccione el cuadrante: </label></div>
              <div class="col">
                <select class="form-select" name="cuadranteuno" [formControl]="Cuadrante1">
                  <option value="">Sin cuadrante</option>
                  <option value="ESTE">ESTE</option>
                  <option value="NORTE">NORTE</option>
                  <option value="OESTE">OESTE</option>
                  <option value="SUR">SUR</option>
                  <option value="ESQUINA">ESQUINA</option>
                </select>
              </div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-6"><label>Ingrese el número que acompaña el prefijo: </label></div>
              <div class="col"><input type="text" name="numprefijouno" class="form-control" [formControl]="NumeroPrefijo1"  maxlength="5" oninput="this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '')"></div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-6"><label>Seleccione la letra que acompaña el prefijo: </label></div>
              <div class="col">
                <select class="form-select" name="letraprefijo" [formControl]="LetraPrefijo">
                  <option value="" selected>Sin letra</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                  <option value="E">E</option>
                  <option value="F">F</option>
                  <option value="G">G</option>
                  <option value="H">H</option>
                  <option value="I">I</option>
                  <option value="J">J</option>
                  <option value="K">K</option>
                  <option value="L">L</option>
                  <option value="M">M</option>
                  <option value="N">N</option>
                  <option value="O">O</option>
                  <option value="P">P</option>
                  <option value="Q">Q</option>
                  <option value="R">R</option>
                  <option value="S">S</option>
                  <option value="T">T</option>
                  <option value="U">U</option>
                  <option value="V">V</option>
                  <option value="W">W</option>
                  <option value="X">X</option>
                  <option value="Y">Y</option>
                  <option value="Z">Z</option>
                </select>
              </div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-6"><label>Ingrese el número que acompaña el prefijo: </label></div>
              <div class="col"><input type="text" name="numprefijodos" class="form-control" [formControl]="NumeroPrefijo2" maxlength="5" oninput="this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '')"></div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row">
              <div class="col-3"><label>Seleccione el cuadrante: </label></div>
              <div class="col">
                <select class="form-select" name="cuadrantedos" [formControl]="Cuadrante2">
                  <option value="">Sin cuadrante</option>
                  <option value="ESTE">ESTE</option>
                  <option value="NORTE">NORTE</option>
                  <option value="OESTE">OESTE</option>
                  <option value="SUR">SUR</option>
                  <option value="ESQUINA">ESQUINA</option>
                </select>
              </div>
              <div class="col-1"><b>*</b></div>
            </div>
            <br>
            <div class="row"><b>Utilice complemento necesarios para completar la dirección</b></div>
            <br>
            <div class="row">
              <div class="col"><label>Seleccione el complemento de la dirección: </label></div>
              <div class="col">
                <select class="form-select" name="complementodirec" [formControl]="Komplemento" (change)="Complemento2()">
                  <option value="">Sin complemento</option>
                  <option value="AD">(AD) Administración</option>
                  <option value="AGN">(AGN) Agencia</option>
                  <option value="AG">(AG) Agrupación</option>
                  <option value="ALM">(ALM) Almacen</option>
                  <option value="AL">(AL) Altillo</option>
                  <option value="APD">(APD) Apartado</option>
                  <option value="AST">(AST) Asentamiento</option>
                  <option value="BRR">(BRR) Barrio</option>
                  <option value="BL">(BL) Bloque</option>
                  <option value="BD">(BD) Bodega</option>
                  <option value="CS">(CS) Casa</option>
                  <option value="CAS">(CAS) Caserio</option>
                  <option value="CE">(CE) Célula</option>
                  <option value="CC">(CC) Centro Comercial</option>
                  <option value="CD">(CD) Ciudadela</option>
                  <option value="CDM">(CDM) Condominio</option>
                  <option value="CJ">(CJ) Conjunto</option>
                  <option value="CJR">(CJR) Conjunto Residencial</option>
                  <option value="CN">(CN) Consultorio</option>
                  <option value="CRG">(CRG) Corregimiento</option>
                  <option value="CTO">(CTO) Cuarto</option>
                  <option value="DO">(DO) Deposito</option>
                  <option value="DS">(DS) Depsito Sótano</option>
                  <option value="ED">(ED) Edificio</option>
                  <option value="EN">(EN) Entrada</option>
                  <option value="ESQ">(ESQ) Esquina</option>
                  <option value="ES">(ES) Estación</option>
                  <option value="ET">(ET) Etapa</option>
                  <option value="EX">(EX) Exterior</option>
                  <option value="FRR">(FRR) Ferrocarril</option>
                  <option value="FI">(FI) Finca</option>
                  <option value="GJ">(GJ) Garaje</option>
                  <option value="GS">(GS) Garaje Sótano</option>
                  <option value="HB">(HB) Habitación</option>
                  <option value="HC">(HC) Hacienda</option>
                  <option value="IN">(IN) Interior</option>
                  <option value="KM">(KM) Kilómetro</option>
                  <option value="LC">(LC) Local</option>
                  <option value="LM">(LM) Local Mezzanine</option>
                  <option value="LT">(LT) Lote</option>
                  <option value="MZ">(MZ) Manzana</option>
                  <option value="MN">(MN) Mezzanine</option>
                  <option value="MD">(MD) Módulo</option>
                  <option value="NV">(NV) Nivel</option>
                  <option value="OF">(OF) Oficina</option>
                  <option value="PA">(PA) Parcela</option>
                  <option value="PAR">(PAR) Parque</option>
                  <option value="PQ">(PQ) Parqueadero</option>
                  <option value="PTN">(PTN) Peatonal</option>
                  <option value="PH">(PH) Penthouse</option>
                  <option value="PS">(PS) Piso</option>
                  <option value="PN">(PN) Plan</option>
                  <option value="PL">(PL) Planta</option>
                  <option value="PZ">(PZ) Plaza</option>
                  <option value="PO">(PO) Portería</option>
                  <option value="PD">(PD) Predio</option>
                  <option value="PT">(PT) Puente</option>
                  <option value="PU">(PU) Puesto</option>
                  <option value="QT">(QT) Quinta</option>
                  <option value="RS">(RS) Residencia</option>
                  <option value="RP">(RP) Round Point</option>
                  <option value="SA">(SA) Salón</option>
                  <option value="SC">(SC) Salón Comunal</option>
                  <option value="SCT">(SCT) Sector</option>
                  <option value="SS">(SS) Semisótano</option>
                  <option value="SL">(SL) Solar</option>
                  <option value="SO">(SO) Sótano</option>
                  <option value="SU">(SU) Suite</option>
                  <option value="SM">(SM) Supermanzana</option>
                  <option value="TM">(TM) Terminal</option>
                  <option value="TZ">(TZ) Terraza</option>
                  <option value="TO">(TO) Torre</option>
                  <option value="UN">(UN) Unidad</option>
                  <option value="UR">(UR) Unidad Residencial</option>
                  <option value="UB">(UB) Urbanización</option>
                  <option value="VD">(VD) Vereda</option>
                  <option value="VIA">(VIA) Vía</option>
                  <option value="VDU">(VDU) Viaducto</option>
                  <option value="ZN">(ZN) Zona</option>
                  <option value="ZF">(ZF) Zona Franca</option>
                </select>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-9"><label>Ingrese el número o letra que acompña el complemento: </label></div>
              <div class="col"><input type="text" name="numletcomp" class="form-control" [(ngModel)]="acomple" [disabled]="Komplemento.hasError('required')"  maxlength="30" oninput="this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '')"></div>
            </div>
            <br>
          <div>
            <div class="row" style="align-content: center; text-align: center;"><b>Dirección</b></div>
            <div><input type="text" name="direccionfinal" class="form-control" disabled placeholder="{{TipoViaPrincipal.value}} {{NombreViaPrincipal.value}} {{LetraViaPrincipal.value}} {{Prefijo.value}} {{Cuadrante1.value}} {{NumeroPrefijo1.value}} {{LetraPrefijo.value}} {{NumeroPrefijo2.value}} {{Cuadrante2.value}} {{acomple}}"></div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary" (click)="NormalizarDireccion2()"
        [disabled]="
        TipoViaPrincipal.hasError('required')||
        NombreViaPrincipal.hasError('required')||
        NumeroPrefijo1.hasError('required')||
        NumeroPrefijo2.hasError('required')
        "
        >Aceptar</button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #closeModalDireccion>Cancelar</button>
      </div>
    </div>
  </div>
</div>
